import { urlHelpers } from '@/links'

const urlOf = route => new URL(`${urlHelpers.originAndBase}${route.fullPath.slice(1)}`)

// Sinatra picks which SPA serves a page only on a full page load, so an in-app navigation to a
// page cut over to Vue 3 would render this SPA's retired copy. Leaving the SPA lets the server
// serve Vue 3. The page the browser is already on is let through, since the server chose this SPA
// for that path and loading it again would loop.
//
// next is deliberately never called on the way out, as authRouteGuard does: aborting would reject
// the promise of every router.push that targets the page, which callers don't catch and Sentry
// reports as an error.
export function vue3RouteGuard(to, from, next) {
  const servedByVue3 = to.matched.some(record => record.meta.servedByVue3)
  const target = urlOf(to)
  if (!servedByVue3 || target.pathname === window.location.pathname) {
    next()
    return
  }

  window.location.assign(target.href)
}
